module.exports = __webpack_public_path__ + "img/iconO.c859bbd3.jpg";